import { useAuth, useTenantsState } from '@frontegg/react'

/* Utils */
import { useAppSelector } from 'store/hooks'
import { accountSettingsSelector } from 'store/user/userSlice'
import { resolveAccountName } from 'lib/accountName'

/* The display name of the signed-in account, for anywhere the operator should see whose data they
 * are looking at. */
export const useAccountName = (): string => {
  const accountSettings = useAppSelector(accountSettingsSelector)
  const { user } = useAuth()
  const { tenants } = useTenantsState()

  return resolveAccountName(accountSettings?.name, tenants, (user?.tenantId as string | undefined) ?? null)
}
